<script lang="ts">
	//Hooks
	import { createEventDispatcher } from 'svelte';
	//Formatters
	import { format } from 'svelte-i18n';
	//Design system components
	import {
		ActionsContainer,
		AdvancedCardV2,
		Button,
		Container,
		IconButton,
		LabelListV2,
		Modal,
		Stack,
		Text,
		Toggle,
	} from '@Shelly/shelly-design-system';
	//Helpers
	import {
		buildScheduleLabels,
		buildUnsupportedLabels,
	} from 'src/helpers/actions/schedules/view/schedule_view_helpers';
	//Components
	import WeekDaysSelected from 'src/components/TimePicker/WeekDaysSelected.svelte';
	//Types
	import type { ScheduleParams, ScheduleRequestData } from 'src/types/requests/schedules/schedules_g2';

	export let list: ScheduleParams[] = [],
		unsupported: ScheduleRequestData[] = [],
		deviceId: string,
		deviceChannels = 1;

	const dispatcher = createEventDispatcher(),
		deleteAction = () => {
			deleteActionModal = false;
			dispatcher('delete', selectedAction);
		};

	let deleteActionModal = false,
		selectedAction: { index: number; id: number };
</script>

<Stack gap="s">
	{#each list as job, i}
		<AdvancedCardV2 size="m" title="" leftSlotBackground>
			<Toggle
				slot="left"
				size="m"
				checked={job.enable}
				on:click={() => {
					job.enable = !job.enable;
					dispatcher('toggle', job);
				}}
				id="toggle-9e9bb18"
				aria-label={$format('label_enable_schedule', {
					default: 'Enable schedule',
				})}
			/>
			<WeekDaysSelected selection={job.days} slot="title" />
			<LabelListV2
				size="m"
				labelList={buildScheduleLabels(job, deviceId, deviceChannels).map((i) => ({
					...i,
					type: job.enable ? null : 'disabled',
				}))}
				slot="main"
				a11yProps={{ isInteractive: false }}
				data-prevent-drawer-swipe
				data-prevent-sidepanel-swipe
			/>
			<ActionsContainer orientation="vertical" type="simple" slot="right">
				<IconButton
					variant="primary"
					icon="fas fa-pen"
					slot="first"
					on:click={() => dispatcher('edit', { ...job, index: i })}
					aria-label={$format('button_edit', { default: 'Edit' })}
				/>
				<IconButton
					icon="fas fa-trash"
					variant="danger"
					slot="second"
					on:click={() => {
						selectedAction = { index: i, id: job.id };
						deleteActionModal = true;
					}}
					aria-label={$format('button_delete', { default: 'Delete' })}
				/>
			</ActionsContainer>
		</AdvancedCardV2>
	{/each}
	{#each unsupported as job, i}
		<AdvancedCardV2 size="m" title="" leftSlotBackground>
			<Toggle
				slot="left"
				size="m"
				checked={job.enable}
				on:click={() => {
					job.enable = !job.enable;
					dispatcher('toggle', job);
				}}
				id="toggle-20bqlpz"
				aria-label={$format('label_enable_schedule', {
					default: 'Enable schedule',
				})}
			/>
			<LabelListV2
				size="m"
				labelList={buildUnsupportedLabels(job, deviceId, deviceChannels).map((i) => ({
					...i,
					type: job.enable ? null : 'disabled',
				}))}
				slot="main"
				a11yProps={{ isInteractive: false }}
				data-prevent-drawer-swipe
				data-prevent-sidepanel-swipe
			/>
			<ActionsContainer orientation="vertical" type="simple" slot="right">
				<IconButton
					icon="fas fa-trash"
					variant="danger"
					slot="second"
					on:click={() => {
						selectedAction = { index: i, id: job.id };
						deleteActionModal = true;
					}}
					aria-label={$format('button_delete', { default: 'Delete' })}
				/>
			</ActionsContainer>
		</AdvancedCardV2>
	{/each}
</Stack>
<Modal
	showModal={deleteActionModal}
	on:close={() => (deleteActionModal = false)}
	title={$format('button_delete', { default: 'Delete' })}
	><svelte:fragment slot="content">
		<Container padding="0">
			<Text class="mb-s">
				{$format('modal_schedule_delete_msg', {
					default: 'Are you sure you want to delete this schedule?',
				})}
			</Text>
		</Container>
	</svelte:fragment>
	<div class="d-flex justify-content-end" slot="footer">
		<Button
			class="min-width-md-m min-width-sm-auto width-md-auto width-sm-full text-nowrap mr-s"
			responsiveSize={{
				sm: 'm',
			}}
			variant="secondary"
			on:click={() => (deleteActionModal = false)}
		>
			{$format('button_cancel', { default: 'Cancel' })}
		</Button>
		<Button
			class="min-width-md-m min-width-sm-auto width-md-auto width-sm-full text-nowrap"
			variant="danger"
			responsiveSize={{
				sm: 'm',
			}}
			on:click={deleteAction}
		>
			{$format('button_delete', { default: 'Delete' })}
		</Button>
	</div>
</Modal>
